function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles = require("./styles");
var _utils = require("../../utils");
var _components = require("../../components");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var HomeGroup = exports.HomeGroup = (0, _react.memo)(function () {
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useContext = (0, _react.useContext)(_utils.AuthContext),
    login = _useContext.login,
    signup = _useContext.signup;
  var Header = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("./Images/Header.svg")
    }, props));
  });
  var PlantKeyMan = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("./Images/PlantKeyMan.svg")
    }, props));
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.headerImageContainer,
      testID: "headerContainer",
      children: (0, _jsxRuntime.jsx)(Header, {
        style: styles.image_Header
      })
    }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.contentContainer,
      testID: "contentContainer",
      children: [(0, _jsxRuntime.jsx)(_components.Logo, {
        style: styles.logo,
        testID: "logo"
      }), (0, _jsxRuntime.jsx)(_components.Heading, {
        style: styles.heading,
        testID: "heading",
        children: t('homeGroup:heading')
      }), (0, _jsxRuntime.jsx)(_components.Button, {
        label: t('homeGroup:signUpLabel'),
        onPress: signup,
        type: _components.ButtonType.brand,
        containerStyle: styles.signUpButton,
        testID: "signUpButton"
      }), (0, _jsxRuntime.jsx)(_components.Text, {
        containerStyle: styles.signInTextContainer,
        textStyle: styles.signInText,
        children: t('homeGroup:signInText')
      }), (0, _jsxRuntime.jsx)(_components.Button, {
        label: t('homeGroup:signInLabel'),
        onPress: login,
        testID: "signInButton"
      }), (0, _jsxRuntime.jsx)(_components.Button, {
        type: _components.ButtonType.brandLink,
        textStyle: styles.findOutMore,
        href: "https://giki.earth/why-use-giki-zero/?utm_source=giki_zero_homepage",
        children: t('homeGroup:findOutMore')
      })]
    }), (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.footerImageContainer,
      testID: "footerContainer",
      children: (0, _jsxRuntime.jsx)(PlantKeyMan, {
        style: styles.image_PlantKeyMan
      })
    })]
  });
});